import { FC } from 'react';
import Layout from '@/components/layout/Layout';
import Pagination from '@/components/ui/pagination/Pagination';
import AlphabetSearch from '@/components/ui/alphabet-search/AlphabetSearch';
import { useGetUrlPath } from '@/hooks/useGetUrlPath';
import Breadcrumbs from '@/components/ui/breadcrumbs/Breadcrumbs';
import ListItem from '@/components/ui/listItem/ListItem';
import SectionTitle from '@/components/ui/section-title/SectionTitle';
import { TAGS_FOR_PAGE } from '@/helpers/variables';
import { ITags, ITagsData } from '@/interfaces/tags.interface';
import { IWidgetsSideBar } from '@/interfaces/widgets.interface';

import { getCurrentPageName } from '@/helpers/helpers';

interface ITagsProps extends IWidgetsSideBar {
  letterSign?: string;
  data: ITags;
}

const Tags: FC<ITagsProps> = ({ data, letterSign, todayWidget, popularBooksWidget }) => {
  const pagesCount = Math.ceil(data?.total_count / TAGS_FOR_PAGE);
  const currentPath = String(useGetUrlPath());
  const isSearchLetterPage = currentPath.includes('letter');
  const currentPathSplit = currentPath.split('/');

  const getSearchLetterWord = () => {
    if (currentPath.includes('page=')) {
      return currentPathSplit[currentPathSplit.length - 2];
    }
    return currentPathSplit[currentPathSplit.length - 1];
  };

  //Seo block
  const SEO_TITLE = `Тэги книг - скачать книги бесплатно${getCurrentPageName(data.page)}`;
  const SEO_DESCRIPTION = 'Тэги книг - скачать книги бесплатно';
  const SEO_CANONICAL = '/tags';

  return (
    <Layout title={SEO_TITLE} description={SEO_DESCRIPTION} canonicalHref={SEO_CANONICAL} pageHref={useGetUrlPath()} breadcrumbs={<Breadcrumbs firstPageName="Тэги" />} todayWidget={todayWidget} popularBooksWidget={popularBooksWidget}>
      <SectionTitle name="Тэги" />
      {/* Нет данных с бэка для поиска по алфавиту */}
      <AlphabetSearch url={'/tags/letter/'} letterSign={String(letterSign)} title="Тэги по алфавиту" />

      {!!data.data.length ? (
        <>
          <ul className="itemsList">
            {data.data.map((item: ITagsData) => (
              <ListItem key={item.id} itemAlias={item.alias} title={item.title} count={item.book_count || 0} alias="tag" />
            ))}
          </ul>
        </>
      ) : (
        <div>{`Тэги не найдены`}</div>
      )}

      <Pagination pagesCount={pagesCount ?? 0} postName={!!isSearchLetterPage ? `tags/letter/${getSearchLetterWord()}/page=` : `tags/page=`} />
    </Layout>
  );
};

export default Tags;
